import React from 'react';
import './style.css';

const TextBox = props => (
  <input
    name={props.name}
    className="input_TextBox"
    type={props.type}
    style={props.style}
    placeholder={props.placeholder}
    value={props.value}
    onChange={props.onChange}
    onKeyPress={props.onKeyPress}
  />
);
export default TextBox;
